<template>
  <sui-page>
    <!-- 페이지 헤더 -->
    <sui-page-header title="[Samples] Container UI" />

    <!-- 페이지 컨텐츠 -->
    <sui-page-contents>
      <!-- 차수 이동 Select Box [S] -->
      <div slot="top">
        <cmp-order-select :option-list="orderOptionList" />
      </div>
      <!-- 차수 이동 Select Box [E] -->

      <!-- Block 9 (S) -->
      <sui-panel
        title="사업장 정보 (필수)"
        required
      >
        <div class="comm_view_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label label="사업장" />
            </div>
            <div class="col-xs-5">
              <div class="comm_label">
                수원
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                label="상세 사업장"
                :required="true"
                :vertical="false"
              />
            </div>
            <div class="col-xs-5">
              <sui-text-field
                placeholder="Input text"
                default
                value
                :disabled="false"
                :clearable="true"
                :readonly="false"
                style="width:100%"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                label="GBM"
                :required="true"
                :vertical="false"
              />
            </div>
            <div class="col-xs-5">
              <sui-text-field
                placeholder="Input text"
                default
                value
                :disabled="false"
                :clearable="true"
                :readonly="false"
                style="width:100%"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label label="관리그룹" />
            </div>
            <div class="col-xs-5">
              <div class="comm_label">
                수원
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                label="수정자"
                :required="true"
                :vertical="false"
              />
            </div>
            <div class="col-xs-5">
              <sui-text-field
                placeholder="Input text"
                default
                value
                :disabled="false"
                :clearable="true"
                :readonly="false"
                style="width:100%"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                label="수정일"
                :required="true"
                :vertical="false"
              />
            </div>
            <div class="col-xs-5">
              <sui-text-field
                placeholder="Input text"
                default
                value
                :disabled="false"
                :clearable="true"
                :readonly="false"
                style="width:100%"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label label="가동일" />
            </div>
            <div class="col-xs-5">
              <div class="comm_label">
                2019-01-31
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                label="가동상태"
                :required="true"
                :vertical="false"
              />
            </div>
            <div class="col-xs-5">
              <sui-text-field
                placeholder="Input text"
                default
                value
                :disabled="false"
                :clearable="true"
                :readonly="false"
                style="width:100%"
              />
            </div>
          </div>
        </div>
      </sui-panel>
      <!-- Block 9 (E) -->

      <!-- Block 1 (S) -->
      <sui-panel
        title="설비대상 지정1"
        panel-box-type="black"
      >
        <div class="comm_scr_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label label="selectbox" />
            </div>
            <div class="col-xs-3">
              <sui-select-box
                :value="{ label: '', key: '' }"
                :option-list="[
                  { label: 'select001 ', key: '' },
                  { label: 'select002', key: '' },
                  { label: 'select003', key: '' },
                  { label: 'select0014', key: '' }
                ]"
                placeholder="selectbox"
              />
              <div class="comp_spacing" />
              <sui-text-field
                placeholder="Input text"
                default
                value
                :disabled="false"
                :clearable="true"
                :readonly="false"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                label="text-field"
                :required="true"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                placeholder="Input text"
                default
                value
                :disabled="false"
                :clearable="true"
                :readonly="false"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                label="text-field"
                :required="true"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                placeholder="Input text"
                default
                value
                :disabled="false"
                :clearable="true"
                :readonly="false"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label label="checkbox" />
            </div>
            <div class="col-xs-3">
              <sui-checkbox
                v-model="multiCheckbox"
                value="Chk1"
              >
                Chk1
              </sui-checkbox>
              <sui-checkbox
                v-model="multiCheckbox"
                value="Chk2"
              >
                Chk2
              </sui-checkbox>
              <sui-checkbox
                v-model="multiCheckbox"
                value="Chk3"
              >
                Chk3
              </sui-checkbox>
              <sui-checkbox
                v-model="multiCheckbox"
                value="Chk4"
              >
                Chk4
              </sui-checkbox>
            </div>
            <div class="col-xs-1">
              <sui-input-label label="radio" />
            </div>
            <div class="col-xs-3">
              <sui-radio
                value="radio1"
              >
                Radio 1
              </sui-radio>
              <sui-radio
                value="radio2"
              >
                Radio 2
              </sui-radio>
              <sui-radio
                value="radio3"
              >
                Radio 3
              </sui-radio>
            </div>
            <div class="col-xs-1">
              <sui-input-label label="date" />
            </div>
            <div class="col-xs-3">
              <sui-date-picker
                :disabled="false"
                sticky
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label label="spin" />
            </div>
            <div class="col-xs-3">
              <sui-spin
                :min="0"
                :step="1"
                :max="10"
              />
            </div>
            <div class="col-xs-1 nodata" />
            <div class="col-xs-3" />
            <div class="col-xs-1 nodata" />
            <div class="col-xs-3" />
          </div>
          <div class="btn_wrap">
            <button
              type="button"
              class="comm_btn_Reset"
            >
              초기화
            </button>
            <button
              type="button"
              class="comm_btn_Scr"
            >
              검색
            </button>
          </div>
        </div>
      </sui-panel>
      <!-- Block 1 (E) -->

      <!-- Block 2 (S) -->
      <sui-panel
        title="설비정보2"
        panel-box-type="red"      
      >
      <div slot="custom">
          <div class="comm_lineR_div" />
          <div class="info caution">
            CIS Spec:모터용량 37KW, 전격전압 380V, 풍량 157m/min
          </div>
        </div>
        <div class="comm_view_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label label="사업장" />
            </div>
            <div class="col-xs-5">
              <div class="comm_label">
                수원
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                label="상세 사업장"
                :required="true"
                :vertical="false"
              />
            </div>
            <div class="col-xs-5">
              <sui-text-field
                placeholder="Input text"
                default
                value
                :disabled="false"
                :clearable="true"
                :readonly="false"
                style="width:100%"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                label="GBM"
                :required="true"
                :vertical="false"
              />
            </div>
            <div class="col-xs-5">
              <sui-text-field
                placeholder="Input text"
                default
                value
                :disabled="false"
                :clearable="true"
                :readonly="false"
                style="width:100%"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label label="관리그룹" />
            </div>
            <div class="col-xs-5">
              <div class="comm_label">
                수원
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                label="수정자"
                :required="true"
                :vertical="false"
              />
            </div>
            <div class="col-xs-5">
              <sui-text-field
                placeholder="Input text"
                default
                value
                :disabled="false"
                :clearable="true"
                :readonly="false"
                style="width:100%"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                label="수정일"
                :required="true"
                :vertical="false"
              />
            </div>
            <div class="col-xs-5">
              <sui-text-field
                placeholder="Input text"
                default
                value
                :disabled="false"
                :clearable="true"
                :readonly="false"
                style="width:100%"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label label="가동일" />
            </div>
            <div class="col-xs-5">
              <div class="comm_label">
                2019-01-31
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                label="가동상태"
                :required="true"
                :vertical="false"
              />
            </div>
            <div class="col-xs-5">
              <sui-text-field
                placeholder="Input text"
                default
                value
                :disabled="false"
                :clearable="true"
                :readonly="false"
                style="width:100%"
              />
            </div>
          </div>
        </div>
      </sui-panel>
      <!-- Block 2 (E) -->

      <!-- Block 3 (S) -->
      <sui-panel title="설정이력3">
        패널3패널3
      </sui-panel>

      <!-- Block 10 (S) -->
      <sui-panel
        title="사업장 정보 (필수)"
        required
      >
        <div class="comm_view_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label label="사업장" />
            </div>
            <div class="col-xs-5">
              <div class="comm_label">
                수원
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                label="상세 사업장"
                :required="true"
                :vertical="false"
              />
            </div>
            <div class="col-xs-5">
              <sui-text-field
                placeholder="Input text"
                default
                value
                :disabled="false"
                :clearable="true"
                :readonly="false"
                style="width:100%"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                label="GBM"
                :required="true"
                :vertical="false"
              />
            </div>
            <div class="col-xs-5">
              <sui-text-field
                placeholder="Input text"
                default
                value
                :disabled="false"
                :clearable="true"
                :readonly="false"
                style="width:100%"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label label="관리그룹" />
            </div>
            <div class="col-xs-5">
              <div class="comm_label">
                수원
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                label="수정자"
                :required="true"
                :vertical="false"
              />
            </div>
            <div class="col-xs-5">
              <sui-text-field
                placeholder="Input text"
                default
                value
                :disabled="false"
                :clearable="true"
                :readonly="false"
                style="width:100%"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                label="수정일"
                :required="true"
                :vertical="false"
              />
            </div>
            <div class="col-xs-5">
              <sui-text-field
                placeholder="Input text"
                default
                value
                :disabled="false"
                :clearable="true"
                :readonly="false"
                style="width:100%"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label label="가동일" />
            </div>
            <div class="col-xs-5">
              <div class="comm_label">
                2019-01-31
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                label="가동상태"
                :required="true"
                :vertical="false"
              />
            </div>
            <div class="col-xs-5">
              <sui-text-field
                placeholder="Input text"
                default
                value
                :disabled="false"
                :clearable="true"
                :readonly="false"
                style="width:100%"
              />
            </div>
          </div>
        </div>
      </sui-panel>
      <!-- Block 10 (E) -->

      <sui-panel title="설정이력4">
        <div slot="custom">
          <div class="comm_line_div" />
          <div class="info">
            CIS Spec:모터용량 37KW, 전격전압 380V, 풍량 157m/min
          </div>
        </div>
        패널4 내용내용내용
      </sui-panel>

      <sui-panel title="설정이력5">
        <!-- title 확장 영역 [S] -->
        <div slot="custom">
          <div class="comm_line_div" />
          <sui-checkbox
            v-model="multiCheckbox"
            value="Happy"
          >
            Happy
          </sui-checkbox>
          <sui-checkbox
            v-model="multiCheckbox"
            value="UnHappy"
          >
            UnHappy
          </sui-checkbox>
        </div>
        <!-- title 확장 영역 [E] -->

        <!-- 패널 내용 [S] -->
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label label="<sui-code-select>" />
          </div>
          <div class="col-xs-10">
            <sui-code-select
              :selected="COD_PAGE_UE"
              :pageId="this.$options.name"
              :initialSelectedIndex="0"
              codeId="COD_PAGE_UE"
            />
          </div>
        </div>
        <!-- 패널 내용 [E] -->
      </sui-panel>

      <sui-panel
        title="설정이력6"
      >
                <div class="comm_view_wrap">
            <div class="row">
                <div class="col-xs-1">
                    <sui-input-label label="사용자로그인ID"></sui-input-label>
                </div>
                <div class="col-xs-5">
                    <sui-text-field placeholder="Input text"></sui-text-field>
                </div>
                <div class="col-xs-1">
                    <sui-input-label label="사용자명"></sui-input-label>
                </div>
                <div class="col-xs-5">
                    <sui-text-field placeholder="Input text"></sui-text-field>
                </div>        
            </div>    
            <div class="row">
                <div class="col-xs-1">
                    <sui-input-label label="사번"></sui-input-label>
                </div>
                <div class="col-xs-5">
                    <sui-text-field placeholder="Input text"></sui-text-field>
                </div>
                <div class="col-xs-1">
                    <sui-input-label label="영문명"></sui-input-label>
                </div>
                <div class="col-xs-5">
                    <sui-text-field placeholder="Input text"></sui-text-field>
                </div>        
            </div>           
        </div>
      </sui-panel>
      <!-- Block 3 (E) -->
        <div class="comm_btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_border"           
          >
            수정
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_border"           
          >
            삭제
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_solid"           
          >
            등록
          </sui-button>
        </div>  

    </sui-page-contents>

    <!-- 페이지 푸터 -->
    <sui-page-footer />
  </sui-page>
</template>
<script>
export default {
  name: 'PGE_FLY_00009', // eslint-disable-line vue/name-property-casing
  data() {
    return {
      // Code[S]
      COD_PAGE_UE: { key: '', label: '' },
      // Code[E]

      multiCheckbox: [],

      // 차수 이동 Select Box [S]
      orderOptionList: [
        {
          key: 'A001',
          order: '1차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          label: '결재중',
          status: 'P',
        },
        {
          key: 'A002',
          order: '2차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          label: '미진행',
          status: 'N',
        },
        {
          key: 'A003',
          order: '3차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          label: '완료',
          status: 'F',
        },
      ],
      // 차수 이동 Select Box [E]
    };
  },
  computed: {
    disabledStartDate() {
      return {
        from: new Date(this.end_date),
        to: null,
      };
    },
    disabledEndDate() {
      return {
        from: null,
        to: new Date(this.start_date),
      };
    },
  },
  watch: {
    totalPageCount(newValue) {
      this.totalDataCount = newValue * 10;
    },
  },
  mounted() {},
};
</script>

<style scoped>
</style>
